import { z } from 'zod'

import { Hash256 } from '../types/Hash256.js'

export const hash256Schema = z.string().transform((value, ctx) => {
  try {
    return Hash256(value)
  } catch {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: `Invalid hash: ${value}`,
    })
    return z.NEVER
  }
})
